(function(){
  'use strict';
  if(window.__titaniumProductGridControlsV312) return;
  window.__titaniumProductGridControlsV312 = true;

  function directProductChildren(grid){
    return Array.prototype.some.call(grid.children || [], function(child){ return child.classList && child.classList.contains('amz-gp'); });
  }
  function markProductGrids(root){
    var scope = root && root.querySelectorAll ? root : document;
    var grids = scope.querySelectorAll('.grid.grid--uniform');
    Array.prototype.forEach.call(grids, function(grid){ if(directProductChildren(grid)) grid.classList.add('amz-product-grid-layout'); });
    if(scope.matches && scope.matches('.grid.grid--uniform') && directProductChildren(scope)) scope.classList.add('amz-product-grid-layout');
  }
  function parseVariants(picker){
    if(picker.__amzGridVariants) return picker.__amzGridVariants;
    var node = picker.querySelector('[data-amz-grid-variants-json]');
    try { picker.__amzGridVariants = JSON.parse(node ? node.textContent : '[]'); } catch(e) { picker.__amzGridVariants = []; }
    return picker.__amzGridVariants;
  }
  function selectedOptions(picker, variants){
    var selected = picker.__amzGridSelectedOptions;
    if(!selected || !selected.length){
      var initial = variantById(variants, picker.getAttribute('data-initial-variant-id')) || variants.find(function(item){ return item.available; }) || variants[0];
      selected = initial && initial.options ? initial.options.slice() : [];
    }else{
      selected = selected.slice();
    }
    Array.prototype.forEach.call(picker.querySelectorAll('[data-amz-grid-option-index]'), function(select){
      var index = Number(select.getAttribute('data-amz-grid-option-index'));
      selected[index] = select.value;
    });
    picker.__amzGridSelectedOptions = selected.slice();
    return selected;
  }
  function exactVariant(variants, options){
    for(var i=0;i<variants.length;i++){
      var values = variants[i].options || [];
      if(values.length === options.length && values.every(function(value,index){ return String(value) === String(options[index]); })) return variants[i];
    }
    return null;
  }
  function variantById(variants, id){
    for(var i=0;i<variants.length;i++) if(String(variants[i].id) === String(id)) return variants[i];
    return null;
  }
  function formatMoney(cents){
    try { if(window.apx && apx.Currency && typeof apx.Currency.formatMoney === 'function') return apx.Currency.formatMoney(cents, apx.settings && apx.settings.moneyFormat); } catch(e) {}
    try { if(window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, window.apx && apx.settings && apx.settings.moneyFormat); } catch(e) {}
    return String((Number(cents || 0) / 100).toFixed(2));
  }
  function updateOptionAvailability(picker, variants, selected){
    var selects = picker.querySelectorAll('[data-amz-grid-option-index]');
    Array.prototype.forEach.call(selects, function(select){
      var index = Number(select.getAttribute('data-amz-grid-option-index'));
      Array.prototype.forEach.call(select.options, function(option){
        var possible = variants.some(function(variant){
          if(!variant.available) return false;
          var values = variant.options || [];
          for(var i=0;i<selected.length;i++){
            var wanted = i === index ? option.value : selected[i];
            if(String(values[i]) !== String(wanted)) return false;
          }
          return true;
        });
        option.disabled = !possible;
      });
    });
  }
  function updateCardPrice(card, variant){
    if(!card || !variant) return;
    var current = card.querySelector('.amz-gp__price--current');
    var regular = card.querySelector('.amz-gp__price--regular');
    var compare = card.querySelector('.amz-gp__price--orig');
    var target = current || regular;
    if(target) target.innerHTML = formatMoney(variant.price);
    if(compare){
      if(variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)){
        compare.innerHTML = formatMoney(variant.compare_at_price);
        compare.hidden = false;
      }else{ compare.hidden = true; }
    }
  }
  function updateCardLinks(card, variant){
    if(!card || !variant) return;
    Array.prototype.forEach.call(card.querySelectorAll('a[href]'), function(link){
      try { var url = new URL(link.href, window.location.origin); url.searchParams.set('variant', variant.id); link.href = url.toString(); } catch(e) {}
    });
  }
  function updateTrigger(card, picker, variant){
    if(!card || !variant) return;
    var trigger = card.querySelector('.amz-qad-trigger');
    if(!trigger) return;
    trigger.setAttribute('data-amz-qad-variant-id', variant.id);
    if(variant.available){
      trigger.disabled = false;
      trigger.removeAttribute('aria-disabled');
      trigger.textContent = picker.getAttribute('data-add-label') || 'Add to cart';
    }else{
      trigger.disabled = true;
      trigger.setAttribute('aria-disabled','true');
      trigger.textContent = picker.getAttribute('data-soldout-label') || 'Sold out';
    }
  }
  function setPickerToVariant(picker, variant){
    if(!variant || !variant.options) return;
    picker.__amzGridSelectedOptions = variant.options.slice();
    Array.prototype.forEach.call(picker.querySelectorAll('[data-amz-grid-option-index]'), function(select){
      var index = Number(select.getAttribute('data-amz-grid-option-index'));
      if(variant.options[index] != null) select.value = variant.options[index];
    });
  }
  function syncPicker(picker, preferredVariant){
    var variants = parseVariants(picker);
    if(!variants.length) return;
    if(preferredVariant) setPickerToVariant(picker, preferredVariant);
    var selected = selectedOptions(picker, variants);
    var variant = exactVariant(variants, selected);
    if(!variant){
      variant = variants.find(function(item){ return item.available; }) || variants[0];
      setPickerToVariant(picker, variant);
      selected = selectedOptions(picker, variants);
    }
    updateOptionAvailability(picker, variants, selected);
    var card = picker.closest('.amz-gp');
    updateTrigger(card, picker, variant);
    updateCardLinks(card, variant);
    updateCardPrice(card, variant);
    picker.setAttribute('data-selected-variant-id', variant.id);
  }
  function initPicker(picker){
    if(picker.__amzGridPickerReady) return;
    picker.__amzGridPickerReady = true;
    var variants = parseVariants(picker);
    var initial = variantById(variants, picker.getAttribute('data-initial-variant-id'));
    syncPicker(picker, initial);
    ['pointerdown','mousedown','touchstart','click'].forEach(function(type){
      picker.addEventListener(type, function(event){ event.stopPropagation(); });
    });
    picker.addEventListener('change', function(event){
      if(!event.target.matches('[data-amz-grid-option-index]')) return;
      event.stopPropagation();
      var selected = selectedOptions(picker, variants);
      selected[Number(event.target.getAttribute('data-amz-grid-option-index'))] = event.target.value;
      picker.__amzGridSelectedOptions = selected;
      syncPicker(picker);
    });
  }
  function init(root){
    var scope = root && root.querySelectorAll ? root : document;
    markProductGrids(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-amz-grid-variant-picker]'), initPicker);
    if(scope.matches && scope.matches('[data-amz-grid-variant-picker]')) initPicker(scope);
  }
  document.addEventListener('click', function(event){
    var swatch = event.target.closest && event.target.closest('.amz-grid-swatch[data-amz-qad-variant-id]');
    if(!swatch) return;
    var card = swatch.closest('.amz-gp');
    var picker = card && card.querySelector('[data-amz-grid-variant-picker]');
    if(!picker) return;
    var variant = variantById(parseVariants(picker), swatch.getAttribute('data-amz-qad-variant-id'));
    if(variant) syncPicker(picker, variant);
  }, true);
  var scheduled = false;
  var observer = new MutationObserver(function(){
    if(scheduled) return;
    scheduled = true;
    requestAnimationFrame(function(){ scheduled = false; init(document); });
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); observer.observe(document.documentElement,{childList:true,subtree:true}); });
  else { init(document); observer.observe(document.documentElement,{childList:true,subtree:true}); }
  document.addEventListener('shopify:section:load', function(event){ init(event.target); });
})();
